import React from 'react';
import '../styles/Footer.css';

function Footer() {
  return (
    <footer className="app-footer">
      <div className="footer-content">
        <p>Centre Équestre - Application Lasertag &copy; {new Date().getFullYear()}</p>
      </div>
    </footer>
  );
}

export default Footer;